import CardTEAsvg from "components/CardTEAsvg";
import { Container, Row, Col } from "react-bootstrap";

function CorporateCardsManagementPage() {
  return (
    <Container>
      <h3 className="my-4">Corporate Cards Management</h3>
      <Row className="justify-content-center align-items-center mb-4 gap-3">
        {/*<Col xs={5} md={4} lg={2} className="p-0">*/}
        {/*  <CardTEAsvg*/}
        {/*    link="/local-admin/corporate-request-history"*/}
        {/*    title="Request History"*/}
        {/*    big={false}*/}
        {/*    ico="faHistory"*/}
        {/*  />*/}
        {/*</Col>*/}
        {/*<Col xs={5} md={4} lg={2} className="p-0">*/}
        {/*  <CardTEAsvg*/}
        {/*    link="/local-admin/corporate-costs-audit"*/}
        {/*    title="Costs Audit"*/}
        {/*    big={false}*/}
        {/*    ico="faFinancialControlling"*/}
        {/*  />*/}
        {/*</Col>*/}
      </Row>
      <Row className="justify-content-center align-items-center mb-4 gap-3">
        <Col xs={5} md={4} lg={2} className="p-0">
          <CardTEAsvg
            link="/local-admin/corporate-cards/statement-upload"
            title="Statement Upload"
            big={false}
            ico="faElectronicData"
          />
        </Col>
        <Col xs={5} md={4} lg={2} className="p-0">
          <CardTEAsvg
            link="/local-admin/corporate-cards/card-holders"
            title="Card Holders"
            big={false}
            ico="faAccountOwner"
            disabled
          />
        </Col>
      </Row>
    </Container>
  );
}

export default CorporateCardsManagementPage;
